import { List } from 'immutable';
import SearchViewFilterRecord from 'SalesContentIndexUI/data/records/SearchViewFilterRecord';
import filter from 'SalesContentIndexUI/data/utils/filter';
import * as SearchFields from 'SalesContentIndexUI/data/constants/SearchFields';
import * as DefaultFilterNames from 'SalesContentIndexUI/data/lib/DefaultFilterNames';
import DefaultSort from 'SalesContentIndexUI/data/lib/DefaultSort';
export const MyUserViewFilter = ({
  looseItemContentType,
  folderContentType,
  getUserId,
  sort,
  useOwnerViewFilters
}) => {
  const filterContentTypeByLooseItems = filter(SearchFields.CONTENT_TYPE_FIELD, looseItemContentType, folderContentType);
  return SearchViewFilterRecord({
    id: useOwnerViewFilters ? DefaultFilterNames.OWNED_BY_ME : DefaultFilterNames.CREATED_BY_ME,
    getFilters: () => List([filterContentTypeByLooseItems, filter(SearchFields.USER_ID_FIELD, getUserId())]),
    getSort: () => sort || DefaultSort
  });
};
export const UserViewFilter = ({
  looseItemContentType,
  folderContentType,
  sort,
  id
}) => {
  const filterContentTypeByLooseItems = filter(SearchFields.CONTENT_TYPE_FIELD, looseItemContentType, folderContentType);
  return SearchViewFilterRecord({
    id: `${DefaultFilterNames.USER}-${id}`,
    type: DefaultFilterNames.USER,
    getFilters: () => List([filterContentTypeByLooseItems, filter(SearchFields.USER_ID_FIELD, id)]),
    getSort: () => sort || DefaultSort
  });
};